import ancestorOrSelf from '../utils.common/ancestorOrSelf';

// Polyfill adapted from https://github.com/rstacruz/details-polyfill

void (function (root, factory) {
    if (typeof exports === 'object') module.exports = factory();
    else factory();
})(this, function () {
    const DETAILS = 'details';
    const SUMMARY = 'summary';

    const supported = checkSupport();
    if (supported) return;
    // Add a classname
    document.documentElement.className += ' no-details';

    window.addEventListener('click', clickHandler);
    window.addEventListener('touch', clickHandler);
    window.addEventListener('keydown', (e) => {
        const target = e.target;

        if (target.nodeName.toLowerCase() === 'summary' && (e.keyCode === 32 || e.keyCode === 13)) {
            e.preventDefault();
            clickHandler(e);
        }
    });

    injectStyle('details-polyfill-style', 'html.no-details ' + DETAILS + ':not([open]) > :not(' + SUMMARY + ') { display: none; }\n');

    /*
     * Click handler for `<summary>` tags
     */

    function clickHandler(e) {
        const summary = ancestorOrSelf(e.target, 'summary');

        if (summary !== null) {
            const details = summary.parentNode;
            if (!details) return;

            if (details.getAttribute('open')) {
                details.open = false;
                details.removeAttribute('open');
            } else {
                details.open = true;
                details.setAttribute('open', 'open');
            }
        }
    }

    /*
     * Checks for support for `<details>`
     */

    function checkSupport() {
        const el = document.createElement(DETAILS);
        if (!('open' in el)) return false;

        el.innerHTML = '<' + SUMMARY + '>a</' + SUMMARY + '>b';
        document.body.appendChild(el);

        const diff = el.offsetHeight;
        el.open = true;
        const result = diff != el.offsetHeight;

        document.body.removeChild(el);
        return result;
    }

    /*
     * Injects styles (idempotent)
     */

    function injectStyle(id, style) {
        if (document.getElementById(id)) return;

        const el = document.createElement('style');
        el.id = id;
        el.innerHTML = style;

        document.getElementsByTagName('head')[0].appendChild(el);
    }
}); // eslint-disable-line semi
